var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mapping-dialog',{ref:"dialog",attrs:{"title":"Create Device Type Mapping","createLabel":"Create","destinations":_vm.destinations,"deviceTypes":_vm.deviceTypes},on:{"payload":_vm.onPayload}})}
var staticRenderFns = []

export { render, staticRenderFns }